import { render, staticRenderFns } from "./JavascriptComponents.vue?vue&type=template&id=9666217c&"
import script from "./JavascriptComponents.vue?vue&type=script&lang=js&"
export * from "./JavascriptComponents.vue?vue&type=script&lang=js&"
import style0 from "./JavascriptComponents.vue?vue&type=style&index=0&id=9666217c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports